/**
 * ai-explanation pure helpers (no React) — kept out of the component files so fast-refresh stays happy
 * (a component module must export only components).
 */
import type { GenerationResult } from "./types";

/**
 * Narrow a generation result to its "indisponible" shape (status + optional reason), or null when the
 * generation succeeded (`ok`). The server's generate/regenerate NEVER throws — it returns this tag — so
 * the panel reads it to render the graceful indisponible state instead of an error.
 */
export function toIndisponible(
  result: GenerationResult | null | undefined,
): { status: "disabled" | "error"; reason?: string } | null {
  if (!result || result.status === "ok") return null;
  return result.reason !== undefined
    ? { status: result.status, reason: result.reason }
    : { status: result.status };
}
